import { all, takeEvery, takeLatest, put, fork, call } from "redux-saga/effects";

import { contentService } from "@iso/services";
import actions from "@iso/redux/contentList/actions";

function* searchContents() {
  yield takeEvery(actions.SEARCH_CONTENTS_REQUEST, function* ({ payload }) {
    const {
      executedTeam,
      types,
      searchKeyword,
      status,
      size,
      page,
    } = payload;
    try {
      const response = yield call(contentService.searchContents, {
        executedTeam,
        types,
        searchKeyword,
        status,
        size,
        page,
      });
      yield put({
        type: actions.SEARCH_CONTENTS_SUCCESS,
        contents: response?.contents ?? [],
        total: response?.total ?? 0,
      });
    } catch (e) {
      yield put({
        type: actions.SEARCH_CONTENTS_ERROR,
        error: e.message,
      });
    }
  });
}

function* getContentsCsv() {
  yield takeLatest(actions.GET_CONTENTS_CSV_REQUEST, function* ({ payload }) {
    const {
      executedTeam,
      types,
      searchKeyword,
      status,
      size,
      page,
      resolve,
      reject,
    } = payload;
    try {
      const response = yield call(contentService.searchContents, {
        executedTeam,
        types,
        searchKeyword,
        status,
        size,
        page,
      });
      const contents = response?.contents ?? [];
      yield put({
        type: actions.GET_CONTENTS_CSV_SUCCESS,
      });
      yield resolve(contents);
    } catch (e) {
      yield put({
        type: actions.GET_CONTENTS_CSV_ERROR,
        error: e.message,
      });
      yield reject(e);
    }
  });
}

export default function* rootSaga() {
  yield all([fork(searchContents), fork(getContentsCsv)]);
}
